import { memo } from 'react'
import MarkdownRender from 'LuxKit/MarkdownRender'
import { getFinePrintSectionIcon } from 'lib/tours/getTourV2Icons'
import Accordion from 'LuxKit/Accordion'

interface Props {
  finePrintSection: App.Tours.V2OfferFinePrintSection
}

function TourV2FinePrintSection(props: Props) {
  const { finePrintSection } = props

  const Icon = getFinePrintSectionIcon(finePrintSection.category)

  return (
    <Accordion
      size="large"
      heading={finePrintSection.title}
      startIcon={<Icon aria-hidden="true" />}
    >
      <MarkdownRender content={finePrintSection.body} fontSize="medium" />
    </Accordion>
  )
}

export default memo(TourV2FinePrintSection)
